// Minimal geometric icons (Phosphor-lite) — kept as inline SVGs to avoid extra dep issues.
import React from "react";

const stroke = "currentColor";
const sw = 1.5;

export const ExamSquareIcon = (p) => (
    <svg viewBox="0 0 24 24" fill="none" {...p}>
        <rect x="4" y="4" width="16" height="16" stroke={stroke} strokeWidth={sw} />
        <path d="M8 10h8M8 14h5" stroke={stroke} strokeWidth={sw} strokeLinecap="round" />
    </svg>
);
export const SearchIcon = (p) => (
    <svg viewBox="0 0 24 24" fill="none" {...p}>
        <circle cx="11" cy="11" r="7" stroke={stroke} strokeWidth={sw} />
        <path d="m20 20-3-3" stroke={stroke} strokeWidth={sw} strokeLinecap="round" />
    </svg>
);
export const MapPinIcon = (p) => (
    <svg viewBox="0 0 24 24" fill="none" {...p}>
        <path d="M12 21s-7-6.5-7-12a7 7 0 1 1 14 0c0 5.5-7 12-7 12z" stroke={stroke} strokeWidth={sw} />
        <circle cx="12" cy="9" r="2.5" stroke={stroke} strokeWidth={sw} />
    </svg>
);
export const CalendarIcon = (p) => (
    <svg viewBox="0 0 24 24" fill="none" {...p}>
        <rect x="3" y="5" width="18" height="16" stroke={stroke} strokeWidth={sw} />
        <path d="M3 9h18M8 3v4M16 3v4" stroke={stroke} strokeWidth={sw} strokeLinecap="round" />
    </svg>
);
export const ClockIcon = (p) => (
    <svg viewBox="0 0 24 24" fill="none" {...p}>
        <circle cx="12" cy="12" r="9" stroke={stroke} strokeWidth={sw} />
        <path d="M12 7v5l3 2" stroke={stroke} strokeWidth={sw} strokeLinecap="round" />
    </svg>
);
export const SeatIcon = (p) => (
    <svg viewBox="0 0 24 24" fill="none" {...p}>
        <path d="M6 20V10a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v10M4 20h16M8 14h8" stroke={stroke} strokeWidth={sw} strokeLinecap="round" />
    </svg>
);
export const CheckIcon = (p) => (
    <svg viewBox="0 0 24 24" fill="none" {...p}>
        <path d="m4 12 5 5L20 6" stroke={stroke} strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
export const DownloadIcon = (p) => (
    <svg viewBox="0 0 24 24" fill="none" {...p}>
        <path d="M12 3v13m0 0-4-4m4 4 4-4M4 21h16" stroke={stroke} strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
export const ArrowRightIcon = (p) => (
    <svg viewBox="0 0 24 24" fill="none" {...p}>
        <path d="M5 12h14m0 0-5-5m5 5-5 5" stroke={stroke} strokeWidth={sw} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
export const BuildingIcon = (p) => (
    <svg viewBox="0 0 24 24" fill="none" {...p}>
        <rect x="4" y="3" width="16" height="18" stroke={stroke} strokeWidth={sw} />
        <path d="M9 8h.01M15 8h.01M9 12h.01M15 12h.01M9 16h.01M15 16h.01" stroke={stroke} strokeWidth={sw} strokeLinecap="round" />
    </svg>
);
export const ShieldIcon = (p) => (
    <svg viewBox="0 0 24 24" fill="none" {...p}>
        <path d="M12 3 4 6v6c0 5 3.5 8.5 8 9 4.5-.5 8-4 8-9V6l-8-3z" stroke={stroke} strokeWidth={sw} strokeLinejoin="round" />
    </svg>
);
export const WifiIcon = (p) => (
    <svg viewBox="0 0 24 24" fill="none" {...p}>
        <path d="M4 9a15 15 0 0 1 16 0M7 12.5a10 10 0 0 1 10 0M10 16a5 5 0 0 1 4 0" stroke={stroke} strokeWidth={sw} strokeLinecap="round" />
        <circle cx="12" cy="19" r="1" fill={stroke} />
    </svg>
);
